import { Transport } from 'src/types';

export const destroyTransports = async (transports: Transport[]): Promise<void> => {
    await Promise.all(transports.map((transport) => ((transport?.destroy) ? transport.destroy() : undefined)));
};
